import "./IntelligenceHub.module.css";
import Header from "@/reusable_sections/Header";
import Intelligence from "./sections/Intelligence";
import Forensic from "./sections/Forensic";
import Institutional from "./sections/Institutional";
import Investigation from "./sections/Investigation";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function IntelligenceHubPage() {
  return <div>
      <Header />
      <Intelligence />
      <Forensic />
      <Institutional />
      <Investigation />
      <Inquiry />
      <Footer />
    </div>;
}